module.exports = __webpack_public_path__ + "img/10.44c98a8a.jpg";